var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquares(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.000000pt",
    height: "15.000000pt",
    viewBox: "0 0 355.000000 356.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,356.000000) scale(0.100000,-0.100000)",
    fill: "rgba(0, 0, 0, 0.54)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 2735 l0 -765 765 0 765 0 0 765 0 765 -765 0 -765 0 0 -765z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1980 2735 l0 -765 765 0 765 0 0 765 0 765 -765 0 -765 0 0 -765z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 805 l0 -765 765 0 765 0 0 765 0 765 -765 0 -765 0 0 -765z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1980 805 l0 -765 765 0 765 0 0 765 0 765 -765 0 -765 0 0 -765z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquares);
export default __webpack_public_path__ + "static/media/squares.e54c3eae8ca0a753f0ec55725fc28c0e.svg";
export { ForwardRef as ReactComponent };